import React, {useState, useRef} from 'react';
import {Translation} from 'react-i18next';
import {Form, Input, Popover, Typography, Space} from 'antd';
import {CheckCircleFilled, CloseCircleOutlined} from '@ant-design/icons';


const incompleteTextType = 'default';
const incompleteIcon = <CloseCircleOutlined style={{ color: '#00000040' }} />;

const completeTextType = 'secondary';
const completeIcon = <CheckCircleFilled style={{ color: '#52c41a' }} />;

const FirstNameInput = ({name, hasError=false, label=null, rules=null, disabled=false, autoFocus=false, useTooltip=true, tooltipPlacement='right', useSuccess=true, ...props}) => {

  const [isVisible, setIsVisible] = useState(false);

  const [isLengthComplete, setIsLengthComplete] = useState(false);

  const inputRef = useRef(null);

  const onChange = e => {
    const val = e.target.value;
    
    // check length
    setIsLengthComplete(val.length >= 1 && val.length <= 40);
  }

  return (
    <Translation>{(t) =>
      <div className="form-group">
        <Popover
          placement={tooltipPlacement}
          trigger="focus"
          title={null}
          visible={useTooltip && isVisible && !isLengthComplete}
          content={
            <>
              <Space direction="vertical">

                <Typography.Text
                  type={isLengthComplete ? completeTextType : incompleteTextType}
                >
                  {isLengthComplete ? completeIcon : incompleteIcon}{' '}
                  {t('input_requirment_length', {min: 1, max: 40})}
                </Typography.Text>

              </Space>
            </>
          }
        >
          <Form.Item
            name={name}
            label={label ? label : t('register_input_first_name')}
            rules={rules
              ? rules
              : [
                  {required: true, message: t('feedback_validation_required')},
                  {min: 1, max: 40, message: t('feedback_validation_length', {min: 1, max: 40})},
                ]}
            // hasFeedback={useSuccess && isLengthComplete && !hasError}
            hasFeedback={true}
            validateStatus={hasError ? "error" : (useSuccess && isLengthComplete ? "success" : null)}
          >
            <Input
              disabled={disabled}
              autoFocus={autoFocus}
              onChange={onChange}
              ref={inputRef}
              onFocus={() => setIsVisible(true)}
              onBlur={() => setIsVisible(false)}
            />
          </Form.Item>
        </Popover>
      </div>
    }</Translation>
  )
}

export default FirstNameInput;
